// extracted by mini-css-extract-plugin
export default {"triangle":"_2XfrI","outer":"_2TSbw","inner":"_3AUec","right":"_1bSLW","left":"_2Tznj"};